import { useState } from "react";
import { toast } from "sonner";
import { Wifi, WifiOff, RefreshCw, AlertOctagon, Download } from "lucide-react";
import { useOfflineStatus, syncNow, refreshSnapshot } from "@/lib/offline";
import { errMsg, fmtTime } from "@/lib/api";

export function OfflineIndicator() {
  const s = useOfflineStatus();
  const [busy, setBusy] = useState(false);
  if (!s.enrolled) return null;
  const view = !s.online ? ["Offline", "bg-slate-800 text-white", WifiOff] : s.status === "syncing" ? ["Syncing", "bg-sky-100 text-sky-900", RefreshCw]
    : s.status === "failed" ? ["Sync failed", "bg-red-100 text-red-800", AlertOctagon] : ["Online", "bg-emerald-50 text-emerald-800", Wifi];
  const [label, tone, Icon] = view;
  const prep = async () => { setBusy(true); try { const d = await refreshSnapshot(); toast.success(`Offline allowance ready: ${d.stock.length} batches, session until ${fmtTime(d.session.expires_at)}`); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  return (
    <div className={`flex flex-wrap items-center gap-3 px-4 sm:px-6 lg:px-10 py-1.5 text-xs ${tone}`} data-testid="offline-indicator" role="status">
      <span className="flex items-center gap-1 font-semibold" data-testid="offline-state"><Icon size={13} className={s.status === "syncing" ? "animate-spin" : ""} />{label}</span>
      <span data-testid="offline-pending-count">{s.pending} pending sync</span>
      {s.error && <span data-testid="offline-error">{s.error}</span>}
      {s.online && <><button className="underline" onClick={syncNow} data-testid="offline-sync-now">Sync now</button>
        <button className="underline flex items-center gap-1" onClick={prep} disabled={busy} data-testid="offline-prepare"><Download size={12} />Prepare offline session</button></>}
    </div>
  );
}
